import { EMoneySourceWidgetType } from '../../types';

export const getWidgetType = (isWidgetInSummary: boolean): EMoneySourceWidgetType => {
  return isWidgetInSummary ? EMoneySourceWidgetType.Buttons : EMoneySourceWidgetType.Tabs;
};
